import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { publishReplay, refCount } from 'rxjs/operators';
import 'rxjs/Rx';
import { Observable } from 'rxjs/Rx';
import { State } from '../../models/state.model';
import { HttpClientService } from '../httpClient/httpclient.service';

@Injectable()
export class StateService {

  states: State[];
  stateEditing: State;

  private cachedFields: Observable<any>;

  constructor (
    private h: HttpClientService,
    private srvNotify: MessageService
  ) { }

  list(
    offset = null,
    limit = null,
    search?: Array<{ key: string, value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number
  ): Observable<any> {
    const params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
    return this.h.getPaged('/koncentro-common/state/states' +
      (params.toString() ? '?' + params.toString().replace(/\+/gi, '%2B').replace(/'/gi, '\'\'') : '' ));
  }

  getAll(country_id: number = null) {
    return this.h.get('/koncentro-common/state/states' + (country_id != null ? '?country_id=' + country_id : ''))
      .map(res => {
        return this.states = res;
      });
  }

  delete(record) {
    return this.h.delete('/koncentro-common/state/states/' + record.id)
      .map(res => {
        // this.states.splice(this.states.indexOf(record), 1);
        this.srvNotify.add({severity: 'info', summary: 'Confirmed', detail: 'State deleted'});
      });
  }

  recover(record) {
    return this.h.put('/koncentro-common/state/states/recover/' + record.id, {})
      .map(res => {
        this.srvNotify.add({severity: 'info', summary: 'Confirmed', detail: 'Country recovered'});
      });
  }

  post(newData) {
    return this.h.post('/koncentro-common/state/states/', newData)
      .map(res => {
        newData.id = res.id;
        // this.states.push(newData);
        this.srvNotify.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
      });
  }

  put(newData) {
    return this.h.put('/koncentro-common/state/states/', newData)
      .map(res => {
        Object.assign(this.stateEditing, newData);
        this.srvNotify.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
      });
  }

  getFields() {
    if (!this.cachedFields) {
      this.cachedFields = this.h.get('/koncentro-common/schema/StateDto').pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFields;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/state/state.service.ts